import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/app-sidebar";
import { useEffect, useState } from "react";
import eventBus from "@/utils/eventBus.ts";
import EditTitleDialog from "@/pages/DetailPage/component/EditTitleDialog.tsx";
import useCounterStore from "@/store";

export default function Layout() {
    const [isEdit, setIsEdit] = useState(false);
    const [topicTitle, setTopicTitle] = useState('');
    const [topicNo, setTopicNo] = useState('');

    const open = useCounterStore(state => state.open);
    const pageOpen = useCounterStore(state => state.pageOpen);
    const mobileSidebarOpen = useCounterStore((state) => state.mobileSidebarOpen);
    const setMobileSidebarOpen = useCounterStore((state) => state.setMobileSidebarOpen);

    useEffect(() => {
        const sidebarChange = (isOpen: boolean) => {
            useCounterStore.getState().setPageOpen(isOpen);
        };
        eventBus.on('sidebarChange', sidebarChange);

        return () => {
            eventBus.off('sidebarChange', sidebarChange);
        };
    }, []);

    function onTitleEdit(title: string, topicNo: string) {
        setTopicTitle(title);
        setTopicNo(topicNo);
        setIsEdit(true);
    }

    function onChangeSuccess(title: string) {
        eventBus.emit('changeTitleSuccess', title);
    }

    const handleNavItemClick = () => {
        setMobileSidebarOpen(false);
    };

    return (
        <SidebarProvider
            className={'bg-[var(--background-left_navigation_web)]'}
            open={open && pageOpen}
            onOpenChange={(open) => {
                useCounterStore.getState().setPageOpen(open);
                useCounterStore.getState().setOpen(open);
            }}
            mobileOpen={mobileSidebarOpen}
            onMobileOpenChange={setMobileSidebarOpen}
        >
            <AppSidebar onTitleEdit={onTitleEdit} onNavItemClick={handleNavItemClick} />
            <main>
                <EditTitleDialog dialogTitle={topicTitle} isOpen={isEdit} topicNo={topicNo} onOpenChange={setIsEdit} onChangeSuccess={onChangeSuccess} />
            </main>
        </SidebarProvider>
    );
}
